import { AddressSysBus, EBoardTypes, ENTBCurrents, PaginationRequest } from '@ews/react-data';
import { useL10n } from '@ews/react-localization-context';
import { IonButton, IonHeader, IonList, IonModal, IonTitle, IonToolbar } from '@ionic/react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useCreateSystemPSU, useFetchSystemPanels, useModifySystemPSU } from '../../../../ReactData/system';
import SettingsSelect from '../../../../Settings/SettingsComponents/SettingsSelect/SettingsSelect';
import SettingsSelectOption from '../../../../Settings/SettingsComponents/SettingsSelectOption/SettingsSelectOption';
import SettingsTextInput from '../../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput';
import style from "./PSUModal.module.scss";
import { ModalProps } from './types';
import { PSU } from '../types';
import { Filter } from '../../types/reportTypes';
import { Locale } from '../../../../../setup/locale';

const standard = {
    type: EBoardTypes.ABB600_1,
    boardId: undefined,
    panelId: 1,
    address: AddressSysBus.ADDR_1,
    fwVersion: '- - - - - -',
    serialNo: '- - - - - -',
    maxCurrent: ENTBCurrents.UNDEF,
    properties: 1,
    ratedCurrent: '',
    fireAlarmCurrent: '',
    bridgingTime: '',
    batteryVoltage: '',
    batteryCapacity: '',
    batteryCount: '',
    secondaryVoltage: ''
} as PSU;
const PSUModal: React.FC<ModalProps> = ({ systemId, isOpen, type, data, onDismiss, onUpdate, title }) =>
{
    const { translate: t } = useL10n();


    const standardPanelFilter: Filter<{}, keyof { name: string; }> = {
    };

    const modal = useRef<HTMLIonModalElement>(null);

    const [_data, setData] = useState<PSU>(standard);
    const [panelData, setPanelData] = useState<{ id: number; name: string; }[]>([]);

    const disableSaveButton = !((_data.panelId || 0) > 0 && (_data.type?.length || 0) > 0 && (_data.maxCurrent?.length || 0) > 0);

    const createNewPSU = useCreateSystemPSU();
    const updatePSU = useModifySystemPSU();
    const fetchPanels = useFetchSystemPanels();

    async function edit()
    {
        if (systemId) {

            await updatePSU(systemId, _data.panelId, _data.boardId!, _data as PSU);
        };
        if (onUpdate) onUpdate();
        close();
    }
    async function create()
    {
        if (systemId) {

            await createNewPSU(systemId, _data.panelId, _data);
        };
        if (onUpdate) onUpdate();
        close();
    }

    function onWillDismiss()
    {
        onDismiss();
    }

    function close()
    {
        setData(standard);
        onDismiss();
        modal.current?.dismiss();
    }

    const getPanels = useCallback(async (id: string, filter: PaginationRequest) =>
    {
        const response = await fetchPanels(id, { ...filter, noPaginate: true }) as unknown as { id: number; name: string; }[];
        if (!response) return;

        const panelData = response.map(item => ({
            id: item.id,
            name: item.name
        }));
        setPanelData(panelData);

    }, [fetchPanels]);

    useEffect(() =>
    {
        if (type === "edit" && data) {
            /* setEntityIdentifiers({ panelId: data.panelId, boardId: data.boardId }); */
            setData(data);
        } else {
            setData(standard);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, standard, type]);
    useEffect(() =>
    {
        if (systemId) { getPanels(systemId, standardPanelFilter); }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [systemId]);
    return <>
        <IonModal
            ref={modal}
            className={style.modal}
            isOpen={isOpen}
            onWillDismiss={onWillDismiss}
        >
            <IonHeader>
                <IonToolbar>
                    <div
                        className={style.header}
                    >
                        <IonTitle>{`${t(title)}`}</IonTitle>
                    </div>
                </IonToolbar>
            </IonHeader>
            <IonList
                className={`ion-padding ${style.scrollableContent}`}
                color="primary">
                <>
                    <SettingsSelect disabled={type === "edit"} required={true} text={"[REACT_PANEL_ID]"} value={_data.panelId} onSelect={(panelId) =>
                    {
                        setData({ ..._data, panelId });
                    }}>
                        {panelData.map((panel) =>
                        {

                            return <SettingsSelectOption key={panel.id} value={panel.id} text={((type === "edit") ? t('[SID_DETAILS_NET_MEMBER]') + " " + panel.id.toString() + ', ' + panel.name : panel.id.toString()) as Locale} />;
                        })}
                    </SettingsSelect>

                    <SettingsSelect required={true} text={"[REACT_EBORD_TYPE]"} value={_data.type} onSelect={(type) =>
                    {
                        setData({ ..._data, type });
                    }}>
                        {Object.entries(EBoardTypes).map(([key, value]) => (
                            <SettingsSelectOption key={key} text={value as unknown as Locale} value={value} />
                        ))}
                    </SettingsSelect>
                    <SettingsSelect required={true} text={"[REACT_ENTB]"} value={_data.maxCurrent} onSelect={(maxCurrent) =>
                    {
                        setData({ ..._data, maxCurrent });
                    }}>
                        {Object.entries(ENTBCurrents)
                            .filter(([key]) => isNaN(Number(key)))
                            .map(([key, value]) => (
                                <SettingsSelectOption key={key} text={value.toString() as Locale} value={value} />
                            ))}
                    </SettingsSelect>
                    {type === "edit" && (
                        <>
                            <SettingsTextInput
                                required={false}
                                text={"COM_FACPMANAGEMENT_FACP_FIELD_SOFTWARE_VERSION_LABEL"}

                                inputType={"text"}
                                value={_data.fwVersion}
                                onBlur={({ value }) =>
                                {
                                    setData({ ..._data, fwVersion: value });
                                }} />
                            <SettingsTextInput
                                required={false}
                                text={"TD_SERIENNUMMER"}

                                inputType={"text"}
                                value={_data.serialNo}
                                onBlur={({ value }) =>
                                {
                                    setData({ ..._data, serialNo: value });
                                }} />
                        </>
                    )}
                    <SettingsTextInput
                        required={false}
                        text={"TD_TEXT"}

                        inputType={"text"}
                        value={_data.text}
                        onBlur={({ value }) =>
                        {
                            setData({ ..._data, text: value });
                        }} />
                    <SettingsTextInput
                        required={false}
                        text={"[REACT_NOMINAL_CURRENT_[A]]"}

                        inputType={"text"}
                        value={_data.text}
                        onBlur={({ value }) =>
                        {
                            setData({ ..._data, ratedCurrent: value });
                        }} />
                    <SettingsTextInput
                        required={false}
                        text={"[REACT_CURRENT_CONSUMPTION_AT_MAINS_FAULT_[MA]]"}

                        inputType={"text"}
                        value={_data.fireAlarmCurrent}
                        onBlur={({ value }) =>
                        {
                            setData({ ..._data, fireAlarmCurrent: value });
                        }} />
                    <SettingsTextInput
                        required={false}
                        text={"[REACT_BRIDGING_TIME_[H]]"}

                        inputType={"text"}
                        value={_data.bridgingTime}
                        onBlur={({ value }) =>
                        {
                            setData({ ..._data, bridgingTime: value });
                        }} />
                    <SettingsTextInput
                        required={false}
                        text={"[REACT_NOMINAL_VOLTAGE_OF_STAND-BY_BATTERY_[V]]"}

                        inputType={"text"}
                        value={_data.batteryVoltage}
                        onBlur={({ value }) =>
                        {
                            setData({ ..._data, batteryVoltage: value });
                        }} />
                    <SettingsTextInput
                        required={false}
                        text={"[REACT_CAPACITY_OF_STAND-BY_BATTERY_[AH]]"}

                        inputType={"text"}
                        value={_data.batteryCapacity}
                        onBlur={({ value }) =>
                        {
                            setData({ ..._data, batteryCapacity: value });
                        }} />
                    <SettingsTextInput
                        required={false}
                        text={"[REACT_NUMBER_FO_STAND-BY_BATTERIES_[PCS.]]"}

                        inputType={"text"}
                        value={_data.batteryCount}
                        onBlur={({ value }) =>
                        {
                            setData({ ..._data, batteryCount: value });
                        }} />
                    <SettingsTextInput
                        required={false}
                        text={"[REACT_NOMINAL_VOLTAGE_SECONDARY_SIDE]"}

                        inputType={"text"}
                        value={_data.secondaryVoltage}
                        onBlur={({ value }) =>
                        {
                            setData({ ..._data, secondaryVoltage: value });
                        }} />
                </>
            </IonList>
            <div className={`${style.buttonContainer} ${style.marginBottom}`}>
                <IonButton
                    slot="start"
                    color={"danger"}
                    onClick={() => close()}>
                    {t("COM_BANNERS_CANCEL")}
                </IonButton>
                <IonButton
                    slot="end"
                    color={"success"}
                    disabled={type === "new" ? disableSaveButton : false}
                    onClick={() =>
                    {
                        if (type === "edit") {
                            edit();
                        } else {
                            create();
                        }
                    }}>
                    {t("COM_FACPMANAGEMENT_USER_SAVE")}
                </IonButton>
            </div>
        </IonModal>
    </>;
};

export default PSUModal;
